import React from 'react';
import {Link} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {messages} from  '../../common/Translations';
import {subscriptionType} from "../subscriptionType";


const CompaniesListDivRow = ({company, categoryOptions, onChange, intl}) => {

    return (
        <div key={company.id}>
            <div className="row">
                <div className="col-xs-12 col-sm-8">
                    <div className="col-12">#{company.id}</div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.name)}:</strong></div>
                    <div className="col-12">{company.name}</div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.email)}:</strong></div>
                    <div className="col-12">{company.email}</div>
                    <div className="col-12"><strong>Abonnementstype:</strong></div>
                    <div className="col-12">{subscriptionType[company.subscriptionType].title}</div>
                </div>
                <div className="col-sx-12 col-sm-4 text-right">
                    <div className="col-12">
                        <div className="btn-group text-right mt-1">
                            <Link
                                to={`/profil/rediger/${company.id}`}
                                className="btn btn-secondary waves-effect list-action mt-2"
                            >
                                <i className="fa fa-pencil"/> {intl.formatMessage(messages.listDropDownButtonEdit)}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </div>
    );
};

export default injectIntl(CompaniesListDivRow);



// WEBPACK FOOTER //
// ./web/src/components/company/list/CompaniesListDivRow.jsx